import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

const ResourceAllocationSkeleton: React.FC = () => (
  <TableContainer component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell {...tableHeaderStyles}>Type</TableCell>
          <TableCell {...tableHeaderStyles}>Name</TableCell>
          <TableCell {...tableHeaderStyles}>Assignment</TableCell>
          <TableCell {...tableHeaderStyles}>Start Date</TableCell>
          <TableCell {...tableHeaderStyles}>End Date</TableCell>
          <TableCell {...tableHeaderStyles}>Status</TableCell>
          <TableCell {...tableHeaderStyles}>Created By</TableCell>
          <TableCell {...tableHeaderStyles}>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(4)].map((_, index) => (
          <TableRow key={index}>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={70} height={20} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={120} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={140} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={80} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={80} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={140} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="circular" width={24} height={24} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ResourceAllocationSkeleton; 